module.exports = __webpack_public_path__ + "img/tag_center@2x.dea8c429.png";